"use client";

import {
  stripePublishableMode,
  useLocalCheckoutHost,
} from "@/lib/checkout-client";

export function CheckoutModeNote({
  context,
}: {
  context: "checkout" | "cancel" | "success" | "setup";
}) {
  const localDev = useLocalCheckoutHost();

  if (!localDev) return null;

  const mode = stripePublishableMode();
  const liveBlocked = mode === "live";
  const invalid = mode === "invalid";

  let detail = "";
  if (liveBlocked) {
    detail =
      "pk_live_ is set — local checkout is blocked. Switch to pk_test_.";
  } else if (invalid) {
    detail =
      "Publishable key is not pk_test_. Use pk_test_, or leave it unset. Mock-paid still needs a blank STRIPE_SECRET_KEY.";
  } else if (mode === "test") {
    detail =
      context === "checkout"
        ? "pk_test_ is set. Pay follows /api/checkout/session (Stripe test mode if the server secret is a real sk_test_)."
        : "Stripe test mode. A Checkout session still returns here after Stripe.";
  } else {
    detail =
      context === "checkout"
        ? "Mock-paid only if STRIPE_SECRET_KEY is blank (empty). Placeholders like sk_test_REPLACE_ME count as set and skip mock. Pay still POSTs /api/checkout/session — 503 is shown, not mocked in the browser."
        : "Local mock-paid is server-side (blank STRIPE_SECRET_KEY + loopback + non-prod). Production never mock-pays.";
  }

  return (
    <aside
      className={
        "checkout-banner" +
        (liveBlocked || invalid ? " checkout-banner--warn" : "")
      }
      role="note"
    >
      <strong>
        {liveBlocked ? "Live Stripe key blocked. " : "Test keys only. "}
      </strong>
      Never paste live keys in the client. The only browser-visible Stripe value
      is <code>NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY</code> (<code>pk_test_</code>
      ). Local mock-paid: blank <code>STRIPE_SECRET_KEY</code>, non-prod runtime,
      loopback host. {detail}
    </aside>
  );
}
